<template>
  <div class="web_top">
    <div class="w1600">
      <div class="logo">
        <a @click="$pushTo(`/web/index`)"><img :src="$bindImg(webinfo.coverImage)" alt="" /></a>
      </div>

      <div class="right_part">
        <ul class="nav" :class="{ show: responsive }">
          <li>
            <a :class="topindex == '1' ? 'on' : ''" @click="$pushTo(`/web/index`)">首页</a>
          </li>
          <li>
            <div class="dropdown vertical-dropdown" @mouseover="showDropdown" @mouseleave="hideDropdown">
              <a :class="topindex == '2' ? 'on' : ''" @click="$pushTo(`/web/business-layout`)">业务布局</a>
              <div class="dropdown-content vertical" v-if="dropdownOpen"
                style="line-height: 50px;font-size: 16px;width: 470px;display: flex;flex-wrap: wrap;justify-content: space-around;position: absolute;left: -28px;overflow: hidden;padding: 0 20px;">
                <a v-for="item in ywbjList" :key="item.id"
                  @click="item.linkUrl ? $tolinkurl(item.linkUrl) : showNotOpenMessage()">{{ item.title }}</a>
              </div>
            </div>
          </li>
          <li>
            <a :class="topindex == '3' ? 'on' : ''" @click="$pushTo(`/web/news`)">新闻资讯</a>
          </li>
          <li>
            <a :class="topindex == '4' ? 'on' : ''" @click="$pushTo(`/web/industry-style`)">行业风采</a>
          </li>
          <li>
            <a :class="topindex == '5' ? 'on' : ''" @click="$pushTo(`/web/serve`)">行业服务</a>
          </li>
          <li>
            <a :class="topindex == '6' ? 'on' : ''" @click="$pushTo(`/web/cooperation`)">商业合作</a>
          </li>
          <li>
            <a :class="topindex == '7' ? 'on' : ''" @click="$pushTo(`/web/about-profile`)">关于我们</a>
          </li>
        </ul>
        <div class="search_btn" @click="$pushTo(`/web/search`)"></div>
        <div class="nav_btn" @click="showNav" :class="{ open: responsive }">
          <span></span>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import "@/assets/style/web.scss";
import { GetItemById } from "@/api/webSite/content";
import { GetPage } from "@/api/webSite/content";

export default {
  data() {
    return {
      responsive: false,
      webinfo: {},
      dropdownOpen: false,
      selectedOption: "业务布局",
      ywbjList: []
    };
  },
  props: {
    //接收父组件传来的值
    topindex: String,
  },
  created() {
    this.loadinfo();
    this.loaywbjList(); //业务布局
  },
  methods: {
    loadinfo() {
      var that = this
      GetItemById({
        columnId: 14
      }).then((res) => {
        that.webinfo = res.body
      }).catch((err) => {

      });
    },
    showNav() {
      this.responsive = !this.responsive;
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    showDropdown() {
      this.dropdownOpen = true;
    },
    hideDropdown() {
      this.dropdownOpen = false;
    },
    // selectOption(option) {
    //   this.selectedOption = option;
    //   if (option === "考前辅导") {
    //     window.open(`http://kaoshi.lanmaiedu.com`, '_blank');
    //   } else if (option === "继续教育") {
    //     window.open(`https://zxgcsjxjy.lanmaiedu.com/`, '_blank');
    //   } else if (option === "行业培训") {
    //     this.$pushTo(``);
    //   }
    //   this.dropdownOpen = false;
    // },
    loaywbjList() {
      var that = this;
      var filter = { columnId: 19 };
      GetPage({
        pageIndex: 1,
        pageSize: 999999,
        filter: JSON.stringify(filter),
      }).then((res) => {
        that.ywbjList = res.body.items;

        console.log("ywbjList", that.ywbjList);
      }).catch((err) => {

      });
    },
    showNotOpenMessage() {
      this.$errorMessage('尚未开通，请稍后再试。');
    },
  },
};
</script>